import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import RecruitmentShell from "@/recruitment/components/RecruitmentShell.jsx";
import RecruitmentHomePage from "@/recruitment/pages/RecruitmentHomePage.jsx";
import ParentApplicationPage from "@/recruitment/pages/ParentApplicationPage.jsx";
import ParentEntryChoicePage from "@/recruitment/pages/ParentEntryChoicePage.jsx";
import AdminCampaignsPage from "@/recruitment/pages/AdminCampaignsPage.jsx";
import AdminCampaignDetailPage from "@/recruitment/pages/AdminCampaignDetailPage.jsx";
import AdminCampaignCreatePage from "@/recruitment/pages/AdminCampaignCreatePage.jsx";

export default function RecruitmentApp() {
  return (
    <BrowserRouter>
      <RecruitmentShell>
        <Routes>
          <Route path="/" element={<RecruitmentHomePage />} />
          <Route path="/parent/entry" element={<ParentEntryChoicePage />} />
          <Route path="/parent" element={<ParentApplicationPage />} />
          <Route path="/admin" element={<AdminCampaignsPage />} />
          <Route path="/admin/campaign/new" element={<AdminCampaignCreatePage />} />
          <Route path="/admin/campaign/:campaignId" element={<AdminCampaignDetailPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </RecruitmentShell>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}
